import { errorServeiceHandler, makeQueryStringDync } from './helper'

export const actGetUserInfo = (context, payload) => {
    return new Promise((resolve, reject) => {
        let url = ''
        if (!payload) {
            url = '/lco/v1/lco.php'
        } else {
            url = '/lco/v1/subuser/' + payload.subuserid
        }
        fetch(context.state.baseUrl + url)
            .then(errorServeiceHandler)
            .then((response) => {
                return response.json();
            }).then((data) => {
                resolve(data)
            }).catch((error) => {
                reject(error)
            });
    });
}



// WEBPACK FOOTER //
// ./src/store/actions.js